import { render, staticRenderFns } from "./OverlayLoader.vue?vue&type=template&id=21ccbaba&"
import script from "./OverlayLoader.vue?vue&type=script&lang=ts&"
export * from "./OverlayLoader.vue?vue&type=script&lang=ts&"
import style0 from "./OverlayLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports